<style type="text/css">

</style>
<template>
  <div class="new_post">
    <form class="forms-sample" style="border-radius: 10px; border: 1px solid gainsboro">
      <h6 class=" sub-title mb-3 color-default font-weight-bold">Main Category Meta Tag's</h6>

      <div class="form-group row">
        <div class="col-md-6">
          <label class="label-form" for="category_title">Category Title<span style="color: red;">*</span>: </label>
          <input type="text" class="form-control" id="category_title" v-model="tagForm.category_title"
            placeholder="Category Tag">
        </div>
        <div class="col-md-6">
          <label class="label-form" for="category_meta_title">Category Meta Title<span
              style="color: red;">*</span>:</label>
          <input type="text" class="form-control" id="category_meta_title" v-model="tagForm.category_meta_title"
            placeholder="Category Meta Tag">
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label class="label-form" for="category_meta_description">Category Meta Description<span
              style="color: red;">*</span>:</label>
          <input type="text" class="form-control" id="category_meta_description"
            v-model="tagForm.category_meta_description" placeholder="Category Tag Description">
        </div>
        <div class="col-md-6">
          <label class="label-form" for="category_meta_keyword">Category Meta Keyword<span
              style="color: red;">*</span>:</label>
          <input type="text" class="form-control" id="category_meta_keyword" v-model="tagForm.category_meta_keyword"
            placeholder="Category Meta Keyword">
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label class="label-form" for="category_description">Category Description<span
              style="color: red;">*</span>:</label>
          <textarea rows="2" class="form-control" id="category_description" v-model="tagForm.category_description"
            placeholder="Category Description"></textarea>
        </div>
      </div>

      <h6 class=" scolor-default font-weight-bold mb-3 mt-4 color-default font-weight-bold">FAQ's Meta Tag's</h6>
      <!-- FAQ's meta tags -->
      <div class="form-group row">
        <div class="col-md-6">
          <label class="label-form" for="faq_title">FAQ's Title<span style="color: red;">*</span>:</label>
          <input type="text" class="form-control" id="faq_title" v-model="tagForm.faq_title" placeholder="FAQ Tag">
        </div>
        <div class="col-md-6">
          <label class="label-form" for="category_meta_title">FAQ's Meta Title<span
              style="color: red;">*</span>:</label>
          <input type="text" class="form-control" id="faq_meta_title" v-model="tagForm.faq_meta_title"
            placeholder="FAQ Meta Tag">
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label class="label-form" for="category_meta_description">FAQ's Meta Description<span
              style="color: red;">*</span>:</label>
          <input type="text" class="form-control" id="faq_meta_description" v-model="tagForm.faq_meta_description"
            placeholder="FAQ Tag Description">
        </div>
        <div class="col-md-6">
          <label class="label-form" for="category_meta_keyword">FAQ's Meta Keyword<span
              style="color: red;">*</span>:</label>
          <input type="text" class="form-control" id="faq_meta_keyword" v-model="tagForm.faq_meta_keyword"
            placeholder="FAQ Meta Keyword">
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label class="label-form" for="category_description">FAQ's Description<span
              style="color: red;">*</span>:</label>
          <textarea rows="2" class="form-control" id="faq_description" v-model="tagForm.faq_description"
            placeholder="FAQ Description"></textarea>
        </div>
      </div>
      <br />
      <div class="text-right">
        <button class="btn btn-primary" @click.prevent="update">Save</button>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from 'axios';
  import 'jodit/build/jodit.min.css';
  import JoditVue from 'jodit-vue';
  import Multiselect from 'vue-multiselect';

  export default {
    components: {
      Multiselect,
      JoditVue,
    },


    data: function () {
      return {
        formHeader: '',
        isLoadingTag: false,
        tagForm: {
          id: 1,
          category_title: '',
          category_meta_title: '',
          category_meta_description: '',
          category_meta_keyword: '',
          category_description: '',
          faq_title: '',
          faq_meta_title: '',
          faq_meta_description: '',
          faq_meta_keyword: '',
          faq_description: '',
        },

      };
    },


    computed: {

    },


    created: function () {
      this.$store.dispatch('metatag/getTag', this.tagForm.id)
        .then((res) => {
          let tag = this.$store.getters['metatag/tag'];
          this.tagForm.category_title = tag.category_title;
          this.tagForm.category_meta_title = tag.category_meta_title;
          this.tagForm.category_meta_description = tag.category_meta_description;
          this.tagForm.category_meta_keyword = tag.category_meta_keyword;
          this.tagForm.category_description = tag.category_description;
          this.tagForm.faq_title = tag.faq_title;
          this.tagForm.faq_meta_title = tag.faq_meta_title;
          this.tagForm.faq_meta_description = tag.faq_meta_description;
          this.tagForm.faq_meta_keyword = tag.faq_meta_keyword;
          this.tagForm.faq_description = tag.faq_description;

        })
        .catch((err) => {
          let response = err.response;
        });
    },

    methods: {

      update() {
        let data = this.tagForm
        this.$store.dispatch('metatag/updateMeta', data)
          .then((res) => {
            if (res.data.errors) {
              this.$toast.warning('Please Filled All Required Fields!');
            }
            if (res.data.message) {
              this.$toast.success(res.data.message);
            }

          })
          .catch((error) => {
            let response = error.response;
            // send error message
            this.$toast.success(response.data.message);
          });

      }
    }
  }
</script>